import { post } from '../axios';

export default {
  
  /**
   * generate screenshots for the LiveView
   * @param {object} templateConfig
   
   * @returns {Promise<string>}
   */
  generateLiveView(templateConfig) {
    const URL = '/generate/screenshot';   
    return new Promise((resolve, reject) => {
      post(
        URL,
        {
          renderer: 'screenshot',
          templateConfig,
          imageType: 'png',
          deviceScaleFactor: '2'
        },
        { responseType: 'arraybuffer' }
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  
  /**
   * generate pdf to export
   * @param {object} body (consisting of templateConfig and name)
   
   * @returns {Promise<string>}
   */
  generatePdf(body) {
    const URL = '/generate/pdf';   
    return new Promise((resolve, reject) => {
      post(
        URL,
        body,
        { responseType: 'arraybuffer' }
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  
  /**
   * generate word to export
   * @param {object} body (consisting of templateConfig and name)
   
   * @returns {Promise<string>}
   */
  generateWord(body) {
    const URL = '/generate/word';   
    return new Promise((resolve, reject) => {
      post(
        URL,
        body,
        { responseType: 'arraybuffer' }
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }
};
